<!-- eslint-disable max-lines -->
<template>
    <div class="home-search-head-page">
        <div class="search-head">
            <inputComplete :widthPopper="474" :inputValue="searchValue" @handleIconClick="searchInputHandle">
            </inputComplete>
            <!-- <el-input v-model="searchValue" class="home-head-input-box" size="mini" placeholder="搜索客户、商机、合同..."
                @clear="clearHandle" clearable @input="inputHandle" @keydown.enter.native="handleIconClick">
                <i slot="suffix" class="custom-icon" @click="handleIconClick"></i>
            </el-input> -->
        </div>
        <el-tabs class="search-tabs" v-loading="loading">
            <el-tab-pane label="CRM数据">
                <div>
                    <div class="status-box">
                        <span :class="['status-item', statusActive === it.type ? 'status-active' : '']"
                            v-for="(it, index) in statusList" :key="index" @click="statusHandle(it)">{{
                                it.title
                            }}
                            ({{ it.num }})
                        </span>
                    </div>
                </div>
                <div class="home-detail-box">
                    <div class="home-detail-item" v-for="(it, inx) in searchList[currentActive]" :key="inx">
                        <div class="home-detail-head">{{ it.title }}</div>
                        <div class="home-detail-content">
                            <span class="home-detail-content-item" v-for="(it2, inx) in formList[currentActive]"
                                :key="inx">
                                <span class="detail-title">{{ it2.label }}</span>
                                <span class="detail-text" v-if="it2.optionsKey"> {{ codesToNames(it[it2.prop],
                                    dictDatas[it2.optionsKey]) }} </span>
                                <span class="detail-text" v-else> {{ it[it2.prop] }} </span>
                            </span>
                        </div>
                    </div>
                    <div class="content-tips" v-if="searchList[currentActive].length === 0"> 没有相关的搜索结果~ </div>
                </div>
                <lots-pagination class="home-search-pagination" :current-page.sync="pageObj[statusActive].pageNo"
                    @current-change="pageChange" @size-change="sizeChange" :pageSize="pageObj[statusActive].pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="getTotal(statusActive)">
                </lots-pagination>
            </el-tab-pane>
            <el-tab-pane label="动态">
                <div class="content-tips"> 敬请期待~ </div>
                <!-- <div>
                    <div class="status-box">
                        <span :class="['status-item', statusActive === it.type ? 'status-active' : '']"
                            v-for="(it, index) in statusList" :key="index" @click="statusHandle(it)">{{
                                it.title
                            }}
                            ({{ it.num }})
                        </span>
                    </div>
                </div>
                <div class="home-detail-box">
                    <div class="home-detail-item" v-for="(it, inx) in searchList.opportunityList" :key="inx">
                        <div class="home-detail-head">{{ it.title }}</div>
                        <div class="home-detail-content">
                            <span class="home-detail-content-item" v-for="(it2, inx) in formList.opportunityList"
                                :key="inx">
                                <span class="detail-title">{{ it2.label }}</span>
                                <span class="detail-text"> {{ it[it2.prop] }} </span>
                            </span>
                        </div>
                    </div>
                </div> -->
            </el-tab-pane>
            <!-- <el-tab-pane label="话题">
                <div class="content-tips">敬请期待~ </div>
            </el-tab-pane> -->
        </el-tabs>
    </div>

</template>

<script>
import { ref, watch, reactive, onMounted, computed, getCurrentInstance } from '@vue/composition-api';
// import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
// import { getFullOpportunities } from '@mdm/api/opportunityModules/opportunityBatch.js';
import { getSearchList } from '@/api/homePageApi.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { formList } from './config.js';
import store from '@/store/index';
import inputComplete from '../inputComplete/Index.vue';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import homeBgPic from '@/assets/images/homeBg.png';
import { Message } from 'element-ui';
import _ from 'lodash';
export default {
    components: { inputComplete, lotsPagination },
    props: {
        inputValue: {
            type: String,
            default: () => {
                return '';
            }
        },
        widthPopper: {
            type: String,
            default: () => {
                return '500';
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const searchValue = ref('');
        const pageObj = reactive({
            1: {
                pageNo: 0,
                pageSize: 20,
                total: 0
            },
            2: {
                pageNo: 0,
                pageSize: 20,
                total: 0
            },
            3: {
                pageNo: 0,
                pageSize: 20,
                total: 0
            }
        });
        const loading = ref(false);
        const getSearchInfo = (isInitStatus = true) => {
            if (searchValue.value === '') {
                return Message.warning('请输入要搜索的内容');
            };
            const params = {
                'keyword': searchValue.value,
                'pageNo': pageObj[statusActive.value].pageNo,
                'pageSize': pageObj[statusActive.value].pageSize,
                'viewTab': statusActive.value
            };
            loading.value = true;
            getSearchList(params).then(res => {
                if (res && +res.code === 0) {
                    statusList.value[0].num = res.data.globalSearchCustomerDto?.totalCount || 0;
                    statusList.value[1].num = res.data.globalSearchOpportunityDto?.totalCount || 0;
                    statusList.value[2].num = res.data.globalSearchContractDto?.totalCount || 0;
                    const newStatus = statusList.value.find(it => it.num > 0);
                    if (pageObj[statusActive.value].pageNo === 1 && isInitStatus && newStatus) {
                        statusActive.value = statusList.value.find(it => it.num > 0).type;
                        currentActive.value = statusList.value.find(it => it.num > 0).list;
                    }
                    const current = statusList.value.find(it => it.type === statusActive.value);

                    searchList[currentActive.value] = res.data[current.filed].list;
                }
            }).finally(() => {
                loading.value = false;
            });
        };
        const getTotal = (val) => {
            const total = statusList.value.find(it => it.type === val)?.num;
            return Number(total);
        };
        const sizeChange = (e) => {
            console.log(e);
            getSearchInfo();
        };
        const pageChange = (e) => {
            console.log(e);
            getSearchInfo();
        };
        const statusActive = ref('1');
        const statusList = ref([
            {
                title: '客户',
                type: '1',
                num: '0',
                list: 'customerList',
                filed: 'globalSearchCustomerDto'
            },
            {
                title: '商机',
                type: '2',
                num: '0',
                list: 'opportunityList',
                filed: 'globalSearchOpportunityDto'
            },
            {
                title: '合同',
                type: '3',
                num: '0',
                list: 'contractList',
                filed: 'globalSearchContractDto'
            }
        ]);
        const codesToNames = computed(() => {
            function codeToName(codes, dictObj) {
                const names = [];
                const codesArr = String(codes) ? String(codes).split(',') : [];
                if (codesArr && codesArr.length) {
                    codesArr.forEach((key) => {
                        if (dictObj && dictObj[key]) {
                            names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                        }
                    });
                }
                return names.join(',');
            };
            return codeToName;
        });
        const clearHandle = () => {

        };
        const inputHandle = () => {

        };
        const handleIconClick = () => {
            setInitPageNo();
            getSearchInfo();
        };
        const currentActive = ref('customerList');
        const statusHandle = it => {
            statusActive.value = it.type;
            currentActive.value = it.list;
            getSearchInfo(false);
        };

        const searchLoad = _.debounce((e) => {
            pageObj[statusActive.value].pageNo++;
            getSearchInfo();
            // eslint-disable-next-line no-magic-numbers
        }, 500);
        const searchInputHandle = (val) => {
            setInitPageNo();
            searchValue.value = val;
            getSearchInfo();
        };
        const searchList = reactive({
            contractList: [

            ],
            opportunityList: [

            ],
            customerList: [

            ]
        });
        const dictDatas = ref({});
        const getDictData = () => {
            const dictCodes = ['SYS_BMS_BUSI_TYPE', 'NEOCRM_OPPORTUNITY_STATUS', 'LMDM_CUSTOMER_CHANNEL', 'SYS_WM_CUSTOMER_STATUS', 'NEOCRM_CUSTOMER_LEVEL',
                'SYS_CR_CONTRACT_STATUS', 'NEOCRM_BUSINESS_TYPE'].join(',');
            return getDictDataApi({
                dictCodes
            }).then(res => {
                if (res && +res.code === 0) {
                    dictDatas.value = res.data;
                }
            });
        };
        const setInitPageNo = () => {
            pageObj[1].pageNo = 1;
            pageObj[2].pageNo = 1;
            pageObj[3].pageNo = 1;
        };
        const ctx = getCurrentInstance();
        onMounted(async () => {
            await getDictData();
        });
        watch(() => store.getters.homeSearchInput, (nVal, oVal) => {
            if (nVal === oVal) return;
            searchValue.value = nVal;
            setInitPageNo();
            getSearchInfo();
        }, { deep: true, immediate: false });
        watch( // 注意：加了immediate: true的话，watch监听要在放在最后，否则报错涉及的调用方法找不到！
            () => ctx.$route,
            (newVal) => {
                if (!['search', 'index'].includes(newVal.name) && document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['padding'] = '10px';
                    document.querySelector('.el-main').style['background'] = '#f3f4f6';
                } else if (document.querySelector('.el-main')) {
                    document.querySelector('.el-main').style['background']
                        = `linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1)),url(${homeBgPic}) center / 100% 100% no-repeat`;
                }
                if (newVal.name === 'search') {
                    if (!_.isEmpty(ctx.$route.params.inputValue)) {
                        searchValue.value = ctx.$route.params.inputValue;
                        setInitPageNo();
                        getSearchInfo();
                    }
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            searchValue,
            clearHandle,
            inputHandle,
            handleIconClick,
            statusList,
            statusActive,
            statusHandle,
            searchList,
            formList,
            currentActive,
            searchLoad,
            codesToNames,
            dictDatas,
            searchInputHandle,
            loading,
            sizeChange,
            pageChange,
            pageObj,
            getTotal
            //
        };
    }
};
</script>
<style lang="less" scoped>
.home-search-head-page {
    padding: 20px;
    width: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.9) 100%);
    border-radius: 4px;
    backdrop-filter: blur(25px);
    padding: 30px 20px;
    border: 1px solid #FFFFFF;

    .status-box {
        display: flex;
        align-items: center;
    }

    .status-item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 13px;
        height: 12px;
        background: #E9EDF3;
        border-radius: 12px;
        border-radius: 12px;
        margin-right: 8px;
        cursor: pointer;
    }

    .status-active {
        color: #FFFFFF;
        background: #2881FF;
    }

    .search-tabs {
        margin-top: 24px;
    }

    .home-detail-box {
        background: #FFFFFF;
        border-radius: 4px;
        padding: 0 24px 24px 24px;
        margin-top: 24px;
        height: calc(100vh - 340px);
        overflow-y: scroll;

        .home-detail-item {
            border-bottom: 1px solid #ECEEF5;
            padding: 24px 0;

            .home-detail-head {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                line-height: 16px;
            }

            .home-detail-content {
                display: flex;
                flex-wrap: wrap;

                .home-detail-content-item {
                    width: 25%;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    line-height: 14px;
                    padding-top: 24px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    .detail-title {
                        display: inline-block;
                        width: 75px;
                        color: #86909C;
                    }

                    .detail-text {
                        color: #333333;
                    }
                }
            }
        }
    }

    .home-search-pagination {
        float: right;
    }
}

.content-tips {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #86909C;
    font-size: 20px;
}

.search-head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .home-head-input-box {
        // background: #FFFFFF;
        height: 36px;
        width: 500px;
    }

    .back-btn {
        width: 60px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 3px;
        border: 1px solid #C0C5CF;
    }

}

.custom-icon {
    background: url('../../../assets/images/icon-search.png') center/cover;
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 16px;
    margin-top: 9px;
    cursor: pointer;
}
</style>
<style lang="less">
.home-search-head-page {
    .el-tabs__header {
        margin-bottom: 20px;
    }

    .el-tabs .el-tabs__item {
        height: 16px !important;
        line-height: 16px !important;
    }
    .el-tabs .el-tabs__item.is-active{
        color: #2881FF;
    }

    .el-tabs__nav {
        height: 18px;
    }

    .el-tabs__active-bar {
        background: #2881FF;
        height: 2px;
    }

    .el-tabs__nav-wrap::after {
        height: 1px;
        background-color: #ECEEF5;
    }
}

.home-head-input-box.el-input .el-input__inner {
    border-radius: 18px !important;
    padding-left: 16px;
    padding-right: 57px;
    height: 36px;
    line-height: 36px;

}

.home-head-input-box.el-input .el-input__suffix .el-input__clear {
    line-height: 36px;
}

.home-head-input-box {
    .el-input__suffix {
        &-inner {
            flex-direction: row-reverse;
            -webkit-flex-direction: row-reverse;
            display: flex;
        }
    }
}
</style>
